<script setup>
    import { MapStyle } from '@/lib/constants/constants';
    import Map from '../project-list/Map.vue';

    const props = defineProps({
        mapData: Object,
        darkTheme: Boolean
    });
</script>

<template>
    <Map :map-data="props.mapData" :map-style="props.darkTheme ? MapStyle.DARK : MapStyle.LIGHT" />
</template>
